import { useParams } from 'react-router-dom'
import { useOrgUsersApi } from '../db/apiOrgUsers'
import { useIsAdmin } from 'src/shared/hooks/useIsAdmin'

export const useGetOrgId = () => {
  const { org_id: org_id_params } = useParams()
  const { orgUser } = useOrgUsersApi()

  return org_id_params || orgUser?.data?.organization_id
}

/**
 * Quote list scope: members always filter by their org. Admins load all quotes
 * except on `/my-account/organizations/:org_id`, where the route org is used.
 */
export const useQuoteListOrgId = () => {
  const { org_id: routeOrgId } = useParams<{ org_id?: string }>()
  const isAdmin = useIsAdmin()
  const { orgUser } = useOrgUsersApi()
  const membershipOrgId = orgUser?.data?.organization_id
  const resolvedOrgId = routeOrgId || membershipOrgId

  return routeOrgId ?? (isAdmin ? undefined : resolvedOrgId)
}
